import * as swcHelpers from '@swc/helpers';
import { DataLayer, calcPrice } from '@grandvisionhq/analytics';
import { Mappers } from '@grandvisionhq/carts-v2';
import { monetate } from '@grandvisionhq/svc-monetate';
import { optionalKey } from '@grandvisionhq/utils';

var CheckoutSteps;
(function(CheckoutSteps) {
    CheckoutSteps["Login"] = 'login';
    CheckoutSteps["Shipping"] = 'shipping';
    CheckoutSteps["Overview"] = 'overview';
    CheckoutSteps["Payment"] = 'payment';
})(CheckoutSteps || (CheckoutSteps = {}));
const checkoutSteps = {
    [CheckoutSteps.Login]: 1,
    [CheckoutSteps.Shipping]: 2,
    [CheckoutSteps.Overview]: 3,
    [CheckoutSteps.Payment]: 4
};
const pushCheckoutEventToDataLayer = (cart, currentStep, currency)=>{
    DataLayer.pushEvent({
        event: 'gvCheckout',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cart.id
                },
                checkout: {
                    actionField: {
                        step: checkoutSteps[currentStep]
                    },
                    products: cart.lineItems.map((lineItem)=>Mappers.mapClientModelToProductObject(lineItem, lineItem.quantity)
                    )
                }
            }
        }
    });
};
const pushExpressCheckoutEventToDataLayer = (cart, currency)=>{
    DataLayer.pushEvent({
        event: 'gvCheckout',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cart.id
                },
                type: 'express checkout',
                checkout: {
                    actionField: {
                        step: 2
                    },
                    products: cart.lineItems.map((lineItem)=>Mappers.mapClientModelToProductObject(lineItem, lineItem.quantity)
                    )
                }
            }
        }
    });
};
const pushPurchaseEventToDataLayer = (order, currency, cartId)=>{
    const { rawLineItems , orderNumber , discountedAmount , totalPrice , shippingMethodPrice , subtotalAmount , taxAmount ,  } = order;
    const discountTotal = discountedAmount;
    const discountCodes = order.discountCodes ? order.discountCodes.map((discountCode)=>discountCode.code
    ).join() : '';
    DataLayer.pushEcommerceEvent({
        event: 'gvPurchase',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cartId !== null && cartId !== void 0 ? cartId : ''
                },
                purchase: {
                    actionField: swcHelpers.objectSpread({
                        id: orderNumber,
                        revenue: calcPrice(totalPrice),
                        tax: taxAmount && calcPrice(taxAmount),
                        shipping: calcPrice(shippingMethodPrice),
                        revenue_includes_tax: 'true',
                        original_revenue: calcPrice(subtotalAmount),
                        discount_revenue: calcPrice(discountTotal)
                    }, optionalKey('coupon', discountCodes)),
                    products: DataLayer.DataLayerUtils.mapOrderLineItemToDataLayerProductObjects(rawLineItems)
                }
            }
        }
    });
};
function mapOrderLineItemsToPurchaseRows(rawLineItems, orderNumber, currency) {
    const regularLineItems = rawLineItems.map((lineItem)=>{
        return {
            currency,
            purchaseId: orderNumber,
            productId: lineItem.product.sku,
            sku: lineItem.product.sku,
            quantity: (lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity) || 1,
            unitPrice: (lineItem.price.unit.gross / 100).toFixed(2)
        };
    });
    return regularLineItems;
}
function trackOrderCompletionEvents(order, currency) {
    const batchEvents = [
        [
            `PaymentType__${order.paymentMethod}`
        ],
        [
            `ShippingMode__${order.deliveryMethod}`
        ], 
    ];
    order === null || order === void 0 ? void 0 : order.lineItems.forEach((lineItem)=>{
        const type = lineItem.productType;
        if (type) {
            batchEvents.push([
                `Product__${type}`
            ]);
        }
    });
    order === null || order === void 0 ? void 0 : order.rawLineItems.forEach((lineItem)=>{
        if ('configurationItems' in lineItem) {
            lineItem.configurationItems.map((configurationItem)=>{
                if (configurationItem.product.productType === 'LensTypes') {
                    batchEvents.push([
                        `Lenses__${configurationItem.product.sku}`
                    ]);
                }
            });
        }
    });
    monetate().trackBatchEvents(...batchEvents);
    monetate().trackPurchases(mapOrderLineItemsToPurchaseRows(order.rawLineItems, order.orderNumber, currency));
}

export { CheckoutSteps, pushCheckoutEventToDataLayer, pushExpressCheckoutEventToDataLayer, pushPurchaseEventToDataLayer, trackOrderCompletionEvents };
//# sourceMappingURL=data-layer.js.map
